import type { GlobalEvents } from "@otto-ec/global-resources/event-q-bus";

/**
 *
 */
export const globalEvents = window.o_global.events<GlobalEvents>();
